import '@/assets/styles/base.css'
import '@/assets/styles/colors.css'
import '@/assets/styles/typography.css'
import '@/assets/styles/utils.css'
import '@/assets/styles/common.css'
import '@/assets/styles/button.css'

import '@/common/modules/popup'

import cssVars from 'css-vars-ponyfill';
import Vue from 'vue';
import router from '@/common/modules/router'
import store from '@/common/modules/store'
import base from '@/components/base/index.vue'

Vue.config.productionTip = false;
Vue.prototype.tsubo = 3.30579;

cssVars();

new Vue({
    el: '#app',
    router,
    store,
    render: (h) => h(base)
});